import Button from '../misc/Button'
export default class Teleporter extends Button {

    constructor(controls, destination, rig, color) {
        super(controls)
        controls.intersectableObjects = [this, ...controls.intersectableObjects]
        this.destination = destination
        this.rig = rig
    }

    click() {
        this.dispatchEvent({type: 'teleport'})
        this.rig.position.set(this.destination.x, this.destination.y, this.destination.z)
    }
}